import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Button, Container } from "reactstrap";
import Loader from "../../components/Common/Loader";
//Import List
import WorkstationsList from "../../components/Lists/WorkstationsList";
//Import actions redux
import { getWorkstations } from "../../store/actions";

class Workstations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      wslist: null,
    };
  }

  componentDidMount() {
    this.props.getWorkstations(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingGetWs === false && prevProps.loadingGetWs === true) {
      let ws = this.props.ws;
      if (ws) {
        this.prepareData(ws);
      }
    }
  }

  prepareData(ws) {
    this.setState({ wslist: ws });
  }
  refresh(event) {
    event.preventDefault();
    this.setState({ wslist: null });
    this.props.getWorkstations(this.state.user);
  }

  newWorkstation(event) {
    event.preventDefault();

    this.props.history.push({
      pathname: "/createworkstation",
      query: { origin_path: "/workstations" },
    });
  }
  render() {
    if (!this.state.wslist) {
      return (
        <React.Fragment>
          <div className="loaderCenter">
            <Loader></Loader>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            <Button
              onClick={(event) => this.refresh(event)}
              color="primary"
              className="btn btn-primary buttonStatus usersButtons"
            >
              {" "}
              <i size="lg" className="mdi  mdi-refresh"></i>
            </Button>
            <Button
              onClick={(event) => this.newWorkstation(event)}
              className="btn btn-primary waves-effect waves-light buttonStatus usersButtons"
            >
              <Link to="createworkstation">
                {this.props.t("Crear nueva estación de trabajo")}
              </Link>
            </Button>
            <WorkstationsList wslist={this.state.wslist} />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetWs, loadingGetWs, ws, successWs } = state.GetWS;
  return { errorGetWs, loadingGetWs, ws, successWs };
};

export default withRouter(
  connect(mapStateProps, {
    getWorkstations,
  })(withNamespaces()(Workstations))
);
